import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class DiagnosisConsultationModalEmptyState extends Vue {
    @Prop({ type: Boolean, default: false }) readonly pathologistView!: boolean

    @Emit()
    create(): void {}
}
